// 排行榜相关API接口
import apiClient, { API_ENDPOINTS } from "@/config/api";

/**
 * 排行榜API类
 */
export class LeaderboardAPI {
  /**
   * 获取阶段排行榜
   */
  static async getStageLeaderboard(stageId, page = 1, pageSize = 20) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.LEADERBOARD.STAGE_LEADERBOARD, {
        stageId,
        page,
        pageSize
      });
      
      return {
        success: true,
        data: response.data || response,
        message: "获取排行榜成功"
      };
    } catch (error) {
      console.error("获取排行榜失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "获取排行榜失败"
      };
    }
  }

  /**
   * 获取排行榜概览
   */
  static async getLeaderboardOverview() {
    try {
      const response = await apiClient.post(API_ENDPOINTS.LEADERBOARD.OVERVIEW);
      
      return {
        success: true,
        data: response.data || response,
        message: "获取排行榜概览成功"
      };
    } catch (error) {
      console.error("获取排行榜概览失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "获取排行榜概览失败"
      };
    }
  }

  /**
   * 获取用户完成记录
   */
  static async getUserCompletions() {
    try {
      const response = await apiClient.post(API_ENDPOINTS.LEADERBOARD.USER_COMPLETIONS);
      
      return {
        success: true,
        data: response.data || response,
        message: "获取用户完成记录成功"
      };
    } catch (error) {
      console.error("获取用户完成记录失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "获取用户完成记录失败"
      };
    }
  }
}

export default LeaderboardAPI;
